//https://github.com/chemerisuk/cordova-plugin-firebase-messaging
//https://medium.com/glucosio-project/whats-new-in-firebase-cloud-messaging-and-how-to-migrate-from-gcm-578019c2167d
export default class PushNotification {
    constructor() {
        this.onMessage = function () { };
        this.onTokenUpdated = function (token, deviceId) { };
        this.hasInited;
    }
    init() {
        if (this.HasInited == true) return;
        this.HasInited = true;

        document.addEventListener("deviceready", this.onDeviceReady.bind(this), false);
    }
    onDeviceReady() {
        // only trigger once
        document.removeEventListener('deviceready', this.onDeviceReady, false);
        if (typeof cordova == 'undefined' || typeof cordova.plugins == 'undefined' || typeof cordova.plugins.firebase == 'undefined') {
            console.error("cordova.plugins.firebase.messaging plugin is missing");
            return;
        }

        //todo: display why the app needs push notifications then request
        cordova.plugins.firebase.messaging.requestPermission({ forceShow: true }).then(function () {
            console.log("You'll get foreground notifications when a push message arrives");
        }.bind(this));

        cordova.plugins.firebase.messaging.onMessage(function (payload) {
            console.log("New foreground FCM message: ", payload);
            var data = payload;
            this.Message(data);
        }.bind(this));

        cordova.plugins.firebase.messaging.onBackgroundMessage(function (payload) {
            console.log("New background FCM message: ", payload);
            var data = payload;
            this.Message(data);
        }.bind(this));

        this.RegisterNotification();
    }
    Message(data) {

        //extract message
        if (data && !data.message) {
            if (data.gcm) data.message = data.gcm.body;
            if (data.aps && data.aps.alert) data.message = data.aps.alert.body;
        }
        //trigger event
        if (this.onMessage)
            this.onMessage(data);
    };
    StorageAvailable(type) {
        try {
            var storage = window[type],
                x = '__storage_test__';
            storage.setItem(x, x);
            storage.removeItem(x);
            return true;
        }
        catch(e) {
            return false;
        }
    };
    RegisterNotification() {

        //no reason to get token if no Id.  There is no way to target the user and generic messages can be sent via firebase  
        //onTokenUpdated will deal with this as it will send it to the server

        //device Id is used to minimize orphans created on the server when the token changes.  User Id cant be used as it will be used across devices
        var deviceId = null;
        if (this.StorageAvailable('localStorage')) {
            deviceId = localStorage.getItem('deviceId');
            if (!deviceId) {
                deviceId = Math.floor(Math.random() * Math.floor(1000000000000));
                if (this.StorageAvailable('localStorage')) localStorage.deviceId = deviceId;
            }
        }

        if (typeof cordova == 'undefined' || typeof cordova.plugins == 'undefined' || typeof cordova.plugins.firebase == 'undefined') {
            console.error("cordova.plugins.firebase.messaging plugin is missing or not ready");
            return  Promise.resolve("cordova.plugins.firebase.messaging plugin is missing or not ready");
        }
       return cordova.plugins.firebase.messaging.getToken().then(function (token) {
            console.log("Got device token: ", token);
            if (this.onTokenUpdated)
                this.onTokenUpdated(token, deviceId);
            //console.log("Sending token to server with userId: ", userId);
            //Gamification.RegisterNotificationFCM(userId, token, deviceId);
            return token;
        }.bind(this)).catch((error) => {
            console.error(error);
          });
    }
}    
